import { Button, FormControl, Grid, TextField } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle } from 'react-feather'

import { LinearLoading } from '../../../../common'
export const EventForm = ({ useFetchInit }) => {

    const {
        FetchData,
        Actions,
        Forms
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen

    const { fetchAInfoEvent } = FetchData
    const { loadingFetchEvent } = fetchAInfoEvent

    const {
        handleClickReturnModal,
        handleClickDeleteEvent,
        onSubmitForm
    } = Actions

    const isForeign = formState.origen !== 'MANUAL'
    const isManual = formState.origen === 'MANUAL'
    const readOnlyMode = isForeign

    
    return (
        <>
            <div className='h4 mt-1 mb-1'>
                {formState.idagenda > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {loadingFetchEvent && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="fecha_evento">* Fecha</label>
                            <TextField
                                id="fecha_evento"
                                name="fecha_evento"
                                value={formState.fecha_evento}
                                onChange={onInputChange}
                                size='small'
                                type="date"
                                variant={readOnlyMode? 'filled': 'outlined'}
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                        <FormControl fullWidth>
                            <label htmlFor="tipo_evento">* Título</label>
                            <TextField
                                id="tipo_evento"
                                name="tipo_evento"
                                value={formState.tipo_evento}
                                onChange={onInputChange}
                                size='small'
                                type="text"
                                variant={readOnlyMode? 'filled': 'outlined'}
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                {(isForeign)&&(
                    <>
                        <div className="pt-2"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="datos_cliente">* Cliente</label>
                                    <TextField
                                        id="datos_cliente"
                                        name="datos_cliente"
                                        value={formState.datos_cliente}
                                        onChange={onInputChange}
                                        size='small'
                                        type="text"
                                        variant={readOnlyMode? 'filled': 'outlined'}
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: readOnlyMode,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </>
                )}
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="descripcion">Observaciones</label>
                            <TextField
                                id="descripcion"
                                name="descripcion"
                                value={formState.descripcion}
                                onChange={onInputChange}
                                // label='Modelo'
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant={readOnlyMode? 'filled': 'outlined'}
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }} sx={{mt:3}}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            {(isManual) && (
                                <>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp;
                                    {(formState.idagenda > 0 && formState.idagenda !== '') && (
                                        <Button
                                            style={{background: "#b10f04"}}
                                            type='button'
                                            variant="contained"
                                            onClick={handleClickDeleteEvent}
                                        >
                                            <i className="fa-solid fa-trash"></i> &nbsp; Eliminar
                                        </Button>
                                    )}
                                </>
                            )}
                            <Button
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                type='button'
                                variant="contained"
                                onClick={handleClickReturnModal}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Volver
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
